export default __webpack_public_path__ + "static/media/example-card.c6a359ab.jpg";